import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[4],
    alignItems: "center",
    height: "100%",
    width: "100%",
    padding: designTokens.spacing[5],
    boxSizing: "border-box",
    "@media (max-width: 480px)": {
      padding: designTokens.spacing[4],
    },
  },
  checkmarkCircle: {
    width: "72px",
    height: "72px",
    borderRadius: "50%",
    backgroundColor: "#d1fae5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  checkmarkIcon: {
    color: "#10b981",
    fontSize: "32px",
  },
  title: {
    width: "100%",
    maxWidth: "90%",
    "@media (min-width: 640px)": {
      width: "50%",
      maxWidth: "80%",
    },
    "@media (max-width: 480px)": {
      fontSize: designTokens.fontSize["2xl"],
      paddingTop: designTokens.spacing[4],
    },
    color: designTokens.neutral[800],
    fontWeight: designTokens.fontWeight.bold,
    fontSize: designTokens.fontSize["3xl"],
    textAlign: "center",
    paddingTop: designTokens.spacing[8],
  },
  messagecontent: {
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[600],
    maxWidth: "640px",
    lineHeight: String(designTokens.lineHeight.normal),
    whiteSpace: "normal",
    marginTop: designTokens.spacing[4],
    "& p": { marginTop: 0, marginBottom: 0 },
    "& ul, & ol": {
      marginTop: designTokens.spacing[2],
      marginBottom: designTokens.spacing[2],
      paddingLeft: designTokens.spacing[5],
    },
    "& li": { marginBottom: designTokens.spacing[1] },
    "@media (max-width: 480px)": {
      fontSize: designTokens.fontSize.sm,
    },
  },
  content: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  exportButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    background: "transparent",
    color: designTokens.neutral[600],
    fontSize: designTokens.fontSize.sm,
    fontWeight: String(designTokens.fontWeight.medium),
    paddingTop: "0",
    paddingBottom: "0",
    paddingLeft: designTokens.spacing[5],
    paddingRight: designTokens.spacing[5],
    height: designTokens.controlHeight.md,
    borderRadius: designTokens.borderRadius.md,
    border: `1px solid ${designTokens.neutral[300]}`,
    cursor: "pointer",
    transition: `border-color ${designTokens.transition.fast}, color ${designTokens.transition.fast}, background ${designTokens.transition.fast}`,
  },
  exportCaption: {
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[400],
    paddingTop: designTokens.spacing[2],
  },
});
